import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useQuery } from 'react-query';

function useGetOneSupportTicket(data = {}) {
  const { enabled = false, configs = {}, ticketId } = data;
  const { params = {} } = configs;
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;

  function getOneTicket() {
    return privateFetch
      .get(`/v1/admin/ticket/${ticketId}/support`, configs)
      .then((res) => res.data);
  }

  return useQuery(['support-ticket-getResource', params], getOneTicket, {
    enabled,
    keepPreviousData: true,
  });
}

export default useGetOneSupportTicket;
